import { InjectionToken } from '@angular/core';

export const SKY_BROWSER_STORAGE = new InjectionToken<Storage>('SKY_BROWSER_STORAGE', {
  providedIn: 'root',
  factory: () => localStorage,
});

export const SKY_SESSION_STORAGE = new InjectionToken<Storage>('SKY_SESSION_STORAGE', {
  providedIn: 'root',
  factory: () => sessionStorage,
});

export const SKY_LOCAL_STORAGE_TOKEN = new InjectionToken('SKY_LOCAL_STORAGE_TOKEN');

export const SKY_SESSION_STORAGE_TOKEN = new InjectionToken('SKY_SESSION_STORAGE_TOKEN');
